import { render, staticRenderFns } from "./MakeCall.vue?vue&type=template&id=70f6b91c&scoped=true&"
import script from "./MakeCall.vue?vue&type=script&lang=js&"
export * from "./MakeCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f6b91c",
  null
  
)

export default component.exports